import { css, keyframes } from '@emotion/react';
import { theme } from '../../theme/theme';

/** 360도 회전 애니메이션. */
const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

/** 원형 스피너. size(px) 기준으로 두께를 비례 산출. */
export const spinnerStyle = (size: number) => css`
  display: inline-block;
  box-sizing: border-box;
  width: ${size}px;
  height: ${size}px;
  border: ${Math.max(2, Math.round(size / 8))}px solid ${theme.color.border};
  border-top-color: ${theme.color.primary};
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
`;
